import React from 'react';
import styled from 'styled-components';

import { Container } from '@/components/Container';
import Section from '@/components/Section/Section';
import { Text } from '@/components/Text';
import { devices } from '@/styles/breakpoints';

const Card = ({ icon, title }) => {
  const Icon = icon;
  return (
    <CardWrapper>
      <Icon />
      <Text>{title}</Text>
    </CardWrapper>
  );
};

export const PaymentProcessinngCards = ({ cards }) => {
  return (
    <Section>
      <Wrapper>
        <Container>
          <WrapperInner>
            {cards?.map((item, idx) => (
              <Card key={idx} icon={item.icon} title={item.title} />
            ))}
          </WrapperInner>
        </Container>
      </Wrapper>
    </Section>
  );
};

const Wrapper = styled.div`
  border: 1px solid rgba(219, 224, 239, 1);
  padding: 24px 0;
  @media only screen and ${devices.desktop} {
    padding: 40px 0;
  }
`;

const WrapperInner = styled.div`
  display: flex;
  row-gap: 24px;
  flex-direction: column;
  @media only screen and ${devices.desktop} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  align-items: start;
  row-gap: 16px;
  flex-direction: column;
`;
